(() => {
  const accordions = document.querySelectorAll('[data-accordion-component]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('[data-accordion-item]');

    items.forEach((item) => {
      const summary = item.querySelector('[data-accordion-trigger]');
      const answer = item.querySelector('[data-accordion-answer]');

      if (!summary || !answer) return;

      answer.style.overflow = 'hidden';

      if (item.open) {
        answer.style.maxHeight = `${getNaturalHeight(answer)}px`;
      } else {
        answer.style.maxHeight = '0px';
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (accordion.dataset.animating === 'true') return;

        if (item.open) {
          closeItem(item, answer);
          return;
        }

        const openSiblings = [...items].filter((sibling) => {
          return sibling !== item && sibling.open;
        });

        accordion.dataset.animating = 'true';

        const closingSiblings = Promise.all(openSiblings.map((sibling) => {
          return closeItem(sibling, sibling.querySelector('[data-accordion-answer]'));
        }));

        openItem(item, answer);

        closingSiblings.then(() => {
          accordion.dataset.animating = 'false';
        });
      });
    });
  });

  function openItem(item, answer) {
    item.open = true;

    if (prefersReducedMotion) {
      answer.style.maxHeight = `${getNaturalHeight(answer)}px`;
      return;
    }

    const naturalHeight = getNaturalHeight(answer);
    answer.style.maxHeight = '0px';
    answer.offsetHeight;

    requestAnimationFrame(() => {
      answer.style.maxHeight = `${naturalHeight}px`;
    });
  }

  function closeItem(item, answer) {
    if (!answer) return Promise.resolve();

    if (prefersReducedMotion) {
      item.open = false;
      answer.style.maxHeight = '0px';
      return Promise.resolve();
    }

    const naturalHeight = getNaturalHeight(answer);
    answer.style.maxHeight = `${naturalHeight}px`;
    answer.offsetHeight;

    return new Promise((resolve) => {
      const finishClose = (event) => {
        if (event.propertyName !== 'max-height') return;

        item.open = false;
        answer.removeEventListener('transitionend', finishClose);
        resolve();
      };

      answer.addEventListener('transitionend', finishClose);

      requestAnimationFrame(() => {
        answer.style.maxHeight = '0px';
      });
    });
  }

  function getNaturalHeight(answer) {
    const currentMaxHeight = answer.style.maxHeight;

    answer.style.maxHeight = 'none';
    const naturalHeight = answer.scrollHeight;
    answer.style.maxHeight = currentMaxHeight;

    return naturalHeight;
  }
})();
